import { readonly, ref } from 'vue';

export interface PipStatus {
    isPipMode: boolean;
    pipMatchId: number | null;
}

const isPipMode = ref(false);
const pipMatchId = ref<number | null>(null);

export function usePipState() {
    function updatePipStatus(status: PipStatus) {
        isPipMode.value = status.isPipMode;
        pipMatchId.value = status.pipMatchId;
    }

    return {
        isPipMode: readonly(isPipMode),
        pipMatchId: readonly(pipMatchId),
        updatePipStatus,
    };
}
